import SoftButton from "components/SoftButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export const RecoverComponentDialog = ({ open, onClose, onAccept }) => {
  const handleAccept = () => {
    onAccept();
    onClose();
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Recover Connector</DialogTitle>
        <DialogContent>
          Recovering this connector allows you to use it again in a flow.
        </DialogContent>
        <DialogActions>
          <SoftButton onClick={onClose} variant="outlined" color="info">
            Close
          </SoftButton>
          <SoftButton variant="contained" color="info" onClick={handleAccept}>
            Recover
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
